<template>
  <div id="app">
    <LayoutSection size="v100">
      <Navbar />
    </LayoutSection>

    <LayoutSection class="mt-60" size="v100">
      <div>
        <router-view />
      </div>
    </LayoutSection>

    <LayoutSection size="v100" id="footer">
      <Footer />
    </LayoutSection>
  </div>
</template>

<script>
import LayoutSection from "@/components/layout/layout-section.vue";
import Navbar from "@/components/navbar/navbar.vue";
import Footer from "@/components/footer/footer.vue";

export default {
  components: {
    LayoutSection,
    Navbar,
    Footer,
  },
};
</script>
